import { brandLabelFromHost } from '@zealot/shared/brands/brandLabelFromHost';
import { getHubBrand } from '@/store';
import type { BrandSource } from './types';
import { namesABrand } from './types';

// gloss
export const urlBrandSource: BrandSource = {
  name: 'url',
  resolve: ({ hostname }) => {
    const label = brandLabelFromHost(hostname);
    if (!label) return null;

    const hub = getHubBrand();
    if (hub.hubLabel === label) {
      const reached = { uuid: hub.uuid, brandID: hub.brandID, code: hub.code ?? hub.brandName };
      if (namesABrand(reached)) return reached;
    }

    return { code: label };
  },
};
